import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import noop from 'lodash/noop';

import { ControlledInput } from '../shared/form/Input';
import SearchIcon from '../shared/svgIcons/SearchIcon';
import { getSearchUrl, escapeQuery } from '../../utils/search/getSearchUrl';

import css from './searchbar.module.scss';

const fieldStyle = {
  height: 36,
  paddingLeft: 20,
  borderRadius: 5,
  width: '100%',
};

export class Searchbar extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    hintText: PropTypes.string,
    hintStyle: PropTypes.object,
    onChange: PropTypes.func,
    initialValue: PropTypes.string,
    autoFocus: PropTypes.bool,
    iconProps: PropTypes.object,
    placeholder: PropTypes.string,
    iconContainerClassName: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleEnterPress = this.handleEnterPress.bind(this);
  }

  onSubmit(event, value) {
    if (!value) {
      return;
    }
    const { history, onSubmit } = this.props;
    const query = escapeQuery(value);
    history.push(getSearchUrl(query));
    onSubmit();
  }

  handleEnterPress(event, value) {
    event.preventDefault();
    this.onSubmit(event, value);
  }

  render() {
    const {
      initialValue,
      placeholder,
      onChange,
      onFocus,
      onBlur,
      iconContainerClassName,
      autoFocus,
      iconProps,
      hintText,
      hintStyle,
    } = this.props;

    return (
      <div data-testid="searchBar" className={css.wrapper}>
        <div className={iconContainerClassName}>
          <SearchIcon
            id="searchIcon"
            key="searchIcon"
            dataTestId="searchBarIcon"
            onClick={this.onSubmit}
            {...iconProps}
          />
        </div>
        <ControlledInput
          hintText={hintText}
          hintStyle={hintStyle}
          autoFocus={autoFocus}
          replaceStyle
          id="searchField"
          data-testid="searchBarInput"
          className={css.field}
          style={fieldStyle}
          onEnterPress={this.handleEnterPress}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          initialValue={initialValue}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

Searchbar.defaultProps = {
  onSubmit: noop,
};

export default withRouter(Searchbar);
